import {useCallback} from 'react';
import './ColorUnit.sass';

export const ColorUnit = ({
  color,
  height = 32,
  width = 32,
  onClick,
  square = false,
  isActive,
  dataQaId,
  disabled = false,
}) => {
  const onClickHandler = useCallback(() => {
    onClick && onClick(color);
  }, [color, onClick]);

  return (
    // biome-ignore lint/a11y/useFocusableInteractive: use a button?
    // biome-ignore lint/a11y/useKeyWithClickEvents: use a button?
    <div
      role="button"
      className={`colors_unit ${onClick && 'colors_unit--clickable'} ${
        square && 'colors_unit--square'
      } ${isActive && 'colors_unit--active'}
      ${disabled && 'colors_unit--disabled'}`}
      style={{backgroundColor: color, height, width}}
      title={color}
      onClick={disabled ? undefined : onClickHandler}
      data-qa-id={dataQaId}
    />
  );
};
